import run from '../../utilities/run';
import $ from 'jquery';
import _ from 'underscore';
import render from "../../utilities/render";
import { setSwitchery, enableSwitchery, disableSwitchery, instantiateSwitchery } from '../../utilities/instantiateSwitchery';
import { getMap } from '../orderType/elementsbindMap';
import { isNull, isNullOrUndefined } from 'util';

import { instantiateSelect2 } from "../../utilities/select2able";
import { handleDisplayFor, setElementsFromScope, hide, show, handleDisplayForV2, setDisabled, disableInput, enableInput } from "../../utilities/selectorHelpers";
import { createPreventDefault } from '../../utilities/general';
import { getAdditionalCarrierMap } from '../orderType/elementsbindMap';

const elementsPageMap = getMap();
const additionalCarrierElementsMap = getAdditionalCarrierMap();
const elsPage = {};
const entryEl = $("<div class='entry-point'></div>");
const targetSelector = "#create-order-type-form";
const additionalCarrierHtml = require('./html/AdditonalCarriers.html');

export default function DetailsTab(wizard) {

	const self = this;
	const wizardEl = wizard.getWizardElement();
	const mainEl = $(".details-tab");
	const editFlag = wizardEl.data("edit-flag");
	const isDup = wizardEl.data("dup-flag");
    let editOrderType = {};
    if (editFlag) {
        editOrderType = wizardEl.data("edit-order-type-data");
    }


	init();

	const orderTypeList = elsPage.orderTypeRetailerList.data('options');
	const fulfillmentList = elsPage.orderTypeFullfillmentCenter.data('options');
	const billingMethodList = elsPage.orderTypeBillingMethod.data('options');
	const carrierList = elsPage.orderTypeCarrier.data('options');
	const countryList = elsPage.orderTypeDetailCountry.data('options');
	const usaStates = elsPage.orderTypeDetailState.data('usa-states');
	const caProvinces = elsPage.orderTypeDetailState.data('ca-provinces');
	const consolidatedOrderTypeList = elsPage.orderTypeRetailerList.data("consolidated-order-type-list");
	const groupedOrderTypeList = _.groupBy(consolidatedOrderTypeList, 'ortRetailerName');
	const retailerZeroList = elsPage.orderTypeRetailerList.data("retailer-zero");
	loadDropDowns();

	function init() {
		setElements();
		bindElements();
	}

	function setElements() {
		setElementsFromScope(elsPage, elementsPageMap, wizardEl);
	};

	function bindElements() {
		elsPage.orderTypeRetailerSwitchSection.hide();  
		elsPage.orderTypeRetailerSwitch.on("change", function(){
			if(!elsPage.orderTypeRetailerSwitch.is(":checked")){
				elsPage.orderTypeRetailerList.val("-1").trigger("change");
				setSwitchery(elsPage.orderTypeDropShipSwitch, false);
				enableInput(elsPage.orderTypeCodeInput);
				elsPage.orderTypeDuplicateError.hide();
				elsPage.orderTypeCodeInput.val("");
				elsPage.orderTypeNameInput.val("");
			}
			handlePackageLabel();
		});

		elsPage.orderTypeDropShipSwitch.on("change", function(){
			handlePackageLabel();
		});

		elsPage.orderTypeBillingMethod.on("change", function (e) {
			if (elsPage.orderTypeBillingMethod.val() === "Third Party") {
				elsPage.carrierDropDownSection.removeClass("hidden");
				elsPage.orderTypedetailAddcarrierDiv.removeClass("hidden");
			} else {
				elsPage.carrierDropDownSection.addClass("hidden");
				elsPage.fedExSection.addClass('hidden');
				elsPage.upsSection.addClass('hidden');
				elsPage.orderTypedetailAddcarrierDiv.addClass("hidden");
				fieldResetForBillMethod();
			}
		});
		elsPage.orderTypeCarrier.on("change", function (e) {
			showHideFedexUPSValues(elsPage.fedExSection, elsPage.upsSection, elsPage.orderTypeCarrier.val(), "mainCarrier");
		});
		
		elsPage.orderTypeDetailCountry.on("change", handleSwitchingStateInput);
		elsPage.orderTypeDetailAddcarrier.on("click", addNewCarriers);
		elsPage.orderTypeRetailerList.on("change", showHideDropFlag);
		elsPage.orderTypeFullfillmentCenter.on("change", changeFullfillmentInformationText);

		elsPage.orderTypeCodeInput.on("blur", orderTypeCodeValidation);

		wizardEl.on("change", ".additionalCarrierDrop", additionalCarrierDiv);
		wizardEl.on("change", ".additional-carrier-country", handleSwitchingStateAddtionaCarrier);
		wizardEl.on("click", ".order-type-detail-remove", handleHideAdditionalCarrier);
	}

	function handlePackageLabel(){
        if(elsPage.orderTypeRetailerSwitch.is(":checked") 
            && !elsPage.orderTypeDropShipSwitch.is(":checked")){
            elsPage.includePackageDiv.show();
        	setSwitchery(elsPage.includePackageLabel, true);
        } else{
            elsPage.includePackageDiv.hide();
        }
	}

	function handleHideAdditionalCarrier(e) {
		if(e != "changeOnMainCarrier"){
			e.preventDefault();
		}
		wizardEl.find(elsPage.additionalCarrierMainDiv).remove();
		wizardEl.find(elsPage.orderTypeDetailRemove).hide();
		wizardEl.find(elsPage.orderTypeDetailAddcarrier).show();
	}

	function orderTypeCodeValidation() {
		let orderTypeCodeValue =elsPage.orderTypeCodeInput.val();
		elsPage.orderTypeCodeInput.val("");
		elsPage.orderTypeCodeInput.val(orderTypeCodeValue.toUpperCase());

	}

	function changeFullfillmentInformationText() {
		if (elsPage.orderTypeFullfillmentCenter.val() != '') {
			elsPage.orderDestinationTabFfcMsg.html('This order type will be fulfilled by the ' + $('#order_type_fulfillmentCenter :selected').text() + '.');
		} else {
			elsPage.orderDestinationTabFfcMsg.html('Order will be fulfilled based on your order processing configurations');
		}

	} 

	function showHideDropFlag() {
		const cotCode = elsPage.orderTypeRetailerList.val();
		//Get only the code for this order type code or an empty list
		const orderTypeList = groupedOrderTypeList[cotCode] || [];

		let showDropShipFlag = false;
		let dropShipAvail = {
			"Y": false,
			"N": false
		};

		$.each(orderTypeList, (index, value) => {
			if (!isNull(value.ortDropShip)) {
				showDropShipFlag = true;

				if (value.ortDropShip) {
					dropShipAvail.Y = true;
				} else {
					dropShipAvail.N = true;
				}
			}
		});

		const dropShipFlagEl = elsPage.orderTypeDropShipSwitch;
		if (showDropShipFlag) {
			disableSwitchery(dropShipFlagEl);
			setSwitchery(dropShipFlagEl, false);
			if (dropShipAvail.Y && dropShipAvail.N) {
				enableSwitchery(dropShipFlagEl);
			} else if (dropShipAvail.Y) {
				setSwitchery(dropShipFlagEl, true);
			}
		} else {
			//Reset the elements
			setSwitchery(dropShipFlagEl, false);
			disableSwitchery(dropShipFlagEl);
		}
		populateOrderTypeAndCode(cotCode);
	}

	function populateOrderTypeAndCode(cotCode) {
		for (let i = 0; i < retailerZeroList.length; i++) {
			if (retailerZeroList[i].ortRetailerName === cotCode && retailerZeroList[i].ortRtlId == 0) {
				elsPage.orderTypeNameInput.val(retailerZeroList[i].ortRetailerName);
				populateAndDisableOrderTypeCode(retailerZeroList[i]);
				break;
			}
		}
	}

	function populateAndDisableOrderTypeCode(orderTypeCodeValue) {
		elsPage.orderTypeCodeInput.val(orderTypeCodeValue.ortTypeCode);
		disableInput(elsPage.orderTypeCodeInput);
	}

	function additionalCarrierDiv() {
		setElementsFromScope(elsPage, additionalCarrierElementsMap, wizardEl);
		const additionalCarrierDropValue = wizardEl.find(elsPage.additionalCarrierDrop);
		showHideFedexUPSValues(elsPage.fedexAccountNumber, elsPage.upsAccountNumber, elsPage.additionalCarrierDrop.val(), "additionalCarrier");
		fieldRestForAdditionalCarrier();
	}

	function showHideFedexUPSValues(fedexAccountDiv, upsAccountDiv, carrierValue, carrierChange) {
		if (carrierValue == "FedEx") {
			fedexAccountDiv.removeClass("hidden");
			upsAccountDiv.addClass("hidden");
		}
		else if (carrierValue == "UPS") {
			upsAccountDiv.removeClass("hidden");
			fedexAccountDiv.addClass("hidden");
		}
		else {
			fedexAccountDiv.addClass("hidden");
			upsAccountDiv.addClass("hidden");
		}
		const additionalCarrierDropDown = wizardEl.find('#additionalCarrier-0');
		if(additionalCarrierDropDown.length > 0 && carrierChange == "mainCarrier"){
			handleHideAdditionalCarrier("changeOnMainCarrier");
			addNewCarriers("changeOnMainCarrier");
		}
	}

	function addNewCarriers(e) {
		if(e != "changeOnMainCarrier"){
			e.preventDefault();
		}
		let arrayIndex = 0;
		const additionalCarrierMainDiv = wizardEl.find('#additionalCarrier-0');
		if (!additionalCarrierMainDiv.length > 0) {
			renderCountryList(countryList);
			const AdditonalCarriersAdd = $(render(additionalCarrierHtml, {
				additionalCarrierDropdown: getRenderedCarrierDropDown(carrierList),
				countryList: renderCountryList(countryList),
				arrayIndex
			}));
			elsPage.orderTypedetailAddcarrierDiv.append(AdditonalCarriersAdd);
			instantiateSelect2(elsPage.orderTypedetailAddcarrierDiv.find('.select2-select'));
			setElementsFromScope(elsPage, additionalCarrierElementsMap, wizardEl);
			fieldResetForAdditionalBillMethod();
		}
		wizardEl.find(elsPage.orderTypeDetailAddcarrier).hide();
	}

	function getRenderedCarrierDropDown(addtionalCarrierDropValue) {
		const carrierValue = elsPage.orderTypeCarrier.val();
		const addtionalCarrierDropHtml = '<option value="{%- addtionalCarrier.cdmValue %}">{%- addtionalCarrier.cdmValue %}</option>';
		const response = _.map(addtionalCarrierDropValue, (addtionalCarrier) => {
			if(carrierValue != addtionalCarrier.cdmValue){
				return render(addtionalCarrierDropHtml, {
					addtionalCarrier: addtionalCarrier
				});
			}
		});
		return response.join("");
	}


	function handleSwitchingStateInput() {
		let countryVal = $('.order-type-detail-country  :selected').val();
		if (countryVal == "US" || countryVal == "CA") {
			elsPage.orderTypeDetailStateDropdown.removeClass("hidden");
			elsPage.destinationTabStateTextWrapper.addClass("hidden");
			getRenderedStatesorProvince(countryVal, elsPage.orderTypeDetailState);
		}
		else {
			elsPage.orderTypeDetailStateDropdown.addClass("hidden");
			elsPage.destinationTabStateTextWrapper.removeClass("hidden");
		}
	}

	function handleSwitchingStateAddtionaCarrier() {

		let countryVal = $('.additional-carrier-country  :selected').val();
		if (countryVal == "US" || countryVal == "CA") {
			wizardEl.find(elsPage.additionalCarrierDetailStateWrapper).removeClass("hidden");
			wizardEl.find(elsPage.additionalCarrierDetailStateTextWrapper).addClass("hidden");
			getRenderedStatesorProvince(countryVal, elsPage.additionalCarrierDetailState);
		}
		else {
			wizardEl.find(elsPage.additionalCarrierDetailStateWrapper).addClass("hidden");
			wizardEl.find(elsPage.additionalCarrierDetailStateTextWrapper).removeClass("hidden");
		}
	}

	function getRenderedStatesorProvince(countryVal, stateComponent) {
		const stateTypeSelect = stateComponent;
		stateTypeSelect.html('');
		let defaultSelectText = "";
		if (countryVal == "US") {
			defaultSelectText = "Select State";
		} else {
			defaultSelectText = "Select Province";
		}
		let option = $('<option />');
		option.attr('value', "-1").text(defaultSelectText);
		option.attr('selected', 'selected');
		option.attr('disabled', 'disabled');
		stateTypeSelect.append(option);
		if (countryVal == "US") {
			$(usaStates).each(function () {
				let option = $('<option />');
				option.attr('value', this.cdmValue).text(this.cdmMeaning);
				stateTypeSelect.append(option);
			});
		}
		else if (countryVal == "CA") {
			$(caProvinces).each(function () {
				let option = $('<option />');
				option.attr('value', this.cdmValue).text(this.cdmMeaning);
				stateTypeSelect.append(option);
			});
		}
		stateTypeSelect.addClass("select2 select");
		instantiateSelect2(stateTypeSelect);
	}

	function loadDropDowns() {
		$(fulfillmentList).each(function () {
			const option = $('<option />');
			option.attr('value', this.facId).text(this.facName);
			elsPage.orderTypeFullfillmentCenter.append(option);
		});

		$(billingMethodList).each(function () {
			const option = $('<option />');
			option.attr('value', this.cdmValue).text(this.cdmMeaning);
			elsPage.orderTypeBillingMethod.append(option);
		});

		$(carrierList).each(function () {
			const option = $('<option />');
			option.attr('value', this.cdmValue).text(this.cdmValue);
			elsPage.orderTypeCarrier.append(option);
		});



		$.each(orderTypeList, function (index, object) {
			let dataAttr;
			if (!isNull(object.ortRetailerName) && !_.isEmpty(object.ortRetailerName)) {
				let value = `${object.ortRetailerName}`;
				const option = $('<option /\>');
				option.data('quick-toggler-target', dataAttr);
				option.attr('value', object.ortRetailerName).text(value);
				elsPage.orderTypeRetailerList.append(option);
			}
		});

		$(countryList).each(function () {
			const option = $('<option />');
			option.attr('value', this.conCode).text(this.conName);
			elsPage.orderTypeDetailCountry.append(option);
		});
		if (editFlag) {
			fillDropDownValues();
		}
	}

	function renderCountryList(countryList) {
		const addtionalCarrierCountryDropHtml = '<option value="{%- addtionalCarrierCountry.conCode %}">{%- addtionalCarrierCountry.conName %}</option>';
		const response = _.map(countryList, (addtionalCarrierCountry) => {
			return render(addtionalCarrierCountryDropHtml, {
				addtionalCarrierCountry: addtionalCarrierCountry
			});
		});

		return response.join("");
	}

	function fieldResetForBillMethod() {
		elsPage.orderTypeCarrier.val("").trigger('change');
		fieldRestForCarrier();
	}

	function fillDropDownValues() {
		
		instantiateSwitchery(elsPage.orderTypeRetailerSwitch, {});
		instantiateSwitchery(elsPage.orderTypeDropShipSwitch, {});
		if(! isNullOrUndefined(editOrderType.retailerName) ){
			setSwitchery(elsPage.orderTypeRetailerSwitch,true);
			if(!isDup){
				elsPage.orderTypeRetailerList.val(editOrderType.retailerName).trigger('change');
				setSwitchery(elsPage.orderTypeDropShipSwitch, editOrderType.dropShip);
			}else{
				setSwitchery(elsPage.orderTypeDropShipSwitch,false);
			}
		}else{
			setSwitchery(elsPage.orderTypeRetailerSwitch,false);
		}
		
		setSwitchery(elsPage.includePackageLabel, editOrderType.includingPackageLabel);
		if(!isDup){
			elsPage.orderTypeNameInput.val(editOrderType.name);
			elsPage.orderTypeCodeInput.val(editOrderType.code);
		}
		if(editOrderType.code.toUpperCase() == "B2B" || editOrderType.code.toUpperCase() == "B2C"){
			elsPage.business.removeClass('hidden');
			if(editOrderType.code.toUpperCase() == "B2B"){
				elsPage.b2b.removeClass('hidden');
				elsPage.b2bPackTab.removeClass('hidden');
				elsPage.packingTab.addClass('hidden');
			}
			if(!isDup){
				disableInput(elsPage.orderTypeCodeInput);
				disableInput(elsPage.orderTypeNameInput);
			}
		}
		if(! isNullOrUndefined(editOrderType.fulfillmentCenter) ){
			elsPage.orderTypeFullfillmentCenter.val(editOrderType.fulfillmentCenter).trigger('change');
		}
		if(! isNullOrUndefined(editOrderType.billing)){
			elsPage.orderTypeBillingMethod.val(editOrderType.billing.billingMethod).trigger('change'); 
			if (!isNullOrUndefined(editOrderType.billing.carriers[0])) {
				if (editOrderType.billing.carriers[0].carrierName.toUpperCase() == 'FEDEX') {
					elsPage.orderTypeCarrier.val(editOrderType.billing.carriers[0].carrierName).trigger('change');
				} else {
					elsPage.orderTypeCarrier.val(editOrderType.billing.carriers[0].carrierName).trigger('change');
					if(! isNullOrUndefined(editOrderType.billing.carriers[0].billToAddress))
					elsPage.orderTypeDetailCountry.val(editOrderType.billing.carriers[0].billToAddress.country).trigger('change'); 
	
					if(! isNullOrUndefined(editOrderType.billing.carriers[0].billToAddress))
					elsPage.orderTypeDetailState.val(editOrderType.billing.carriers[0].billToAddress.state).trigger('change'); 

				}
			}
			if(!isNullOrUndefined(editOrderType.billing.carriers[1])){
				setElementsFromScope(elsPage, additionalCarrierElementsMap, wizardEl);
				if (editOrderType.billing.carriers[1].carrierName.toUpperCase() == 'FEDEX') {
					elsPage.additionalCarrierDrop.val(editOrderType.billing.carriers[1].carrierName).trigger('change');
					elsPage.additionalCarrierFedexNumber.val(editOrderType.billing.carriers[1].accountNumber);
				}else{
					elsPage.additionalCarrierDrop.val(editOrderType.billing.carriers[1].carrierName).trigger('change');
					elsPage.additionalCarrierCountry.val(editOrderType.billing.carriers[1].billToAddress.country).trigger('change');
					elsPage.additionalCarrierDetailState.val(editOrderType.billing.carriers[1].billToAddress.state).trigger('change'); 
					elsPage.additionalCarrierUPSNumber.val(editOrderType.billing.carriers[1].accountNumber);
					elsPage.additionalCarrierBillTo.val(editOrderType.billing.carriers[1].billToAddress.name);
					elsPage.additionalCarrierAddress1.val(editOrderType.billing.carriers[1].billToAddress.addressLine1);
					if(!isNullOrUndefined(editOrderType.billing.carriers[1].billToAddress.addressLine2)){
						elsPage.additionalCarrierAddress2.val(editOrderType.billing.carriers[1].billToAddress.addressLine2);
					}
					elsPage.additionalCarrierCity.val(editOrderType.billing.carriers[1].billToAddress.city);
					elsPage.additionalCarrierDetailStateText.val(editOrderType.billing.carriers[1].billToAddress.state);
					elsPage.additionalCarrierPostalCode.val(editOrderType.billing.carriers[1].billToAddress.postalCode);
				}
			}
	
		}
	}

	function fieldRestForCarrier() {
		elsPage.orderTypeFedexAccountNumber.val("");
		elsPage.orderTypeUpsAccountNumber.val("");
		elsPage.orderTypeBillto.val("");
		elsPage.orderTypeDetailCountry.val("").trigger('change');
		elsPage.orderTypeDetailAddress.val("");
		elsPage.orderTypeDetailAddress2.val("");
		elsPage.orderTypeDetailCity.val("");
		elsPage.orderTypeDetailState.val("").trigger('change');
		elsPage.orderTypeDetailStateInput.val("");
		elsPage.orderTypeDetailPostalcode.val("");
	}

	function fieldResetForAdditionalBillMethod() {
		wizardEl.find(elsPage.additionalCarrierDrop).val("").trigger('change');
		fieldRestForAdditionalCarrier();
	}

	function fieldRestForAdditionalCarrier() {
		wizardEl.find(elsPage.additionalCarrierFedexNumber).val("");
		wizardEl.find(elsPage.additionalCarrierUPSNumber).val("");
		wizardEl.find(elsPage.additionalCarrierBillTo).val("");
		wizardEl.find(elsPage.additionalCarrierAddress1).val("");
		wizardEl.find(elsPage.additionalCarrierAddress2).val("");
		wizardEl.find(elsPage.additionalCarrierCity).val("");
		wizardEl.find(elsPage.additionalCarrierDetailStateText).val("");
		wizardEl.find(elsPage.additionalCarrierPostalCode).val("");
	}
}


// WEBPACK FOOTER //
// ./src/pages/orderType/detailsTab.js